import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';

import { PureComponent, GroupBox } from 'core/components';
import { withLocale } from 'core/decorators';
import { BlockTitle, Row, Col, Icon, CardContent, Link, Button } from 'core/components/Framework7';

import classes from './styles.module.css';

import ShareImage from 'assets/images/crown.svg'
import { BREAK_LINE } from 'core/pkg/utils/statics';

class Share extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      env: this.initialValue,
    }

    // console.log(this.state.env)
  }

  static get defaultProps() {
    return {
      item: null
    }
  }

  get initialValue() {
    const { env } = this.props;

    return {
      page: env && env.pages && env.pages.share || {},

      registerLink: env && env.info && env.info.registerLink || '',
      shareMessage: env && env.info && env.info.shareMessage || [''],
    }
  }

  shareMessage(prefix = '') {
    const { env } = this.state;
    const { user } = this.props;

    return (
      `${prefix}${env.shareMessage.join(BREAK_LINE)}${BREAK_LINE}${env.registerLink}${user && user.username || ''}`
    )
  }

  share() {
    const { env } = this.state;
    const { user } = this.props;

    const options = {
      message: env.shareMessage.join(BREAK_LINE), // not supported on some apps (Facebook, Instagram)
      subject: env.shareMessage[0],
      url: env.registerLink ? env.registerLink + user.username : null,
    };

    window.plugins.socialsharing.shareWithOptions(options);
    // window.plugins.socialsharing.share(text, null, null, link + user.username)
  }

  render() {
    const { user } = this.props;
    const { env } = this.state

    return (
      <div className={classes.container}>
        <BlockTitle className={classes.pageTitle}>
          {env.page.title}
        </BlockTitle>
        <Col className={classes.codeBox}>
          <Row>
            <img src={ShareImage} className={classes.image} />
          </Row>
          <Row>
            <Link fill large
              className={classes.code}
              onClick={this.share}
            >
              <Col className={classes.title}>
                {'کد شما'}
              </Col>
              <Col className={classes.username}>
                {user && user.username}
              </Col>
              <Col>
                <Icon icon="mdi-cellphone-message" />
                <span>{'ارسال کد معرف'}</span>
              </Col>
            </Link>
          </Row>
          {!this.$device.cordova &&
            <React.Fragment>
              <br />
              <Row>
                <Button
                  icon='mdi-email'
                  onClick={() => { window.open(this.shareMessage('mailto:?body='), '_system'); return false; }}
                />
                <Button
                  icon='mdi-message-processing'
                  onClick={() => { window.open(this.shareMessage('sms:?&body='), '_system'); return false; }}
                />
                <Button
                  icon='mdi-telegram'
                  onClick={() => { window.open(this.shareMessage('tg://msg?text='), '_system'); return false; }}
                />
                <Button
                  icon='mdi-whatsapp'
                  onClick={() => { window.open(this.shareMessage('whatsapp://send?text='), '_system'); return false; }}
                />
              </Row>
            </React.Fragment>
          }
        </Col>
        {env.page.description && env.page.description.length > 0 &&
          <GroupBox outline title={'توضیحات'}>
            <CardContent>
              {
                env.page.description.map((text, index) => {
                  return <div key={index}>{`- ${text}`}</div>
                })
              }
            </CardContent>
          </GroupBox>
        }
      </div>
    )
  }
}

const initialState = state => ({
  env: state.General.env,
  user: state.General.user,
})

export default connect(
  initialState,
  {

  }
)(withLocale('add_address')(autobind(Share)))
